export function createElement({ type = 'DIV', classNames = [], attributes = null, parent = null, content = null, children = [], } = {}) {
    const e = document.createElement(type);
    if (classNames.length) {
        e.classList.add(...classNames);
    }
    if (attributes) {
        Object.entries(attributes).forEach(([name, value]) => {
            e.setAttribute(name, value);
        });
    }
    if (content) {
        e.innerText = content;
    }
    if (children.length) {
        e.append(...children);
    }
    if (parent) {
        parent.appendChild(e);
    }
    return e;
}
//# sourceMappingURL=create-element.js.map